import { useTranslation } from 'react-i18next';
import {
  AdminKpiCard,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Grid,
} from '@shared/ui';

export function AdminKpiCardShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.dataDisplay.adminKpiCard.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.dataDisplay.adminKpiCard.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <Grid cols={4} gap="md" className="grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
          <AdminKpiCard title={t('uiLibrary.dataDisplay.adminKpiCard.items.total')} value="1,248" />
          <AdminKpiCard title={t('uiLibrary.dataDisplay.adminKpiCard.items.admins')} value="24" />
          <AdminKpiCard
            title={t('uiLibrary.dataDisplay.adminKpiCard.items.instructors')}
            value="302"
          />
          <AdminKpiCard
            title={t('uiLibrary.dataDisplay.adminKpiCard.items.students')}
            value="922"
          />
        </Grid>
      </CardContent>
    </Card>
  );
}
